<template>
  <div class="keyVisualWrapper" :style="styles">
    <div :class="{'container': !noContainer}">
      <div :class="{'row':addRow}">
        <img class="desktop_img img-fluid w-100" :src="desktopImagePath" alt="Banner" @error="handleImageError">
        <img class="tablet_img img-fluid w-100" :src="tabletImagePath" alt="Banner" :style="tabletImgStyles" @error="handleImageError">
        <img class="mobile_img img-fluid w-100" :src="mobileImagePath" alt="Banner" :style="mobileImgStyles" @error="handleImageError">
        <p v-if="altText" id="imageDescription" class="visually-hidden">{{$t(this.altText)}}</p>
      </div>
    </div>
  </div>
</template>

<script>
// List of supported locales in the project
const SUPPORTED_LOCALES = ['dk', 'fi', 'no', 'se'];
const DEFAULT_LOCALE = 'dk';

export default {
  name: "key-visual",
  props: {
    desktopImageUrl: {
      type: String
    },
    mobileImageUrl: {
      type: String
    },
    tabletImageUrl: {
      type: String
    },
    addRow: {
      type: Boolean
    },
    noContainer: {
      type: Boolean
    },
    mobileImgStyles: {
      type: Object,
      default: () => {}
    },
    tabletImgStyles: {
      type: Object,
      default: () => {}
    },
    styles: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    currentLocale () {
      return this.locale || DEFAULT_LOCALE;
    },
    safeLocale () {
      return SUPPORTED_LOCALES.includes(this.currentLocale)
        ? this.currentLocale
        : DEFAULT_LOCALE;
    },
    desktopImagePath () {
      return this.desktopImageUrl || `/assets/banner/${this.safeLocale}/banner_desktop.jpg?v=2`;
    },
    tabletImagePath () {
      return this.tabletImageUrl || `/assets/banner/${this.safeLocale}/banner_desktop.jpg?v=2`;
    },
    mobileImagePath () {
      return this.mobileImageUrl || `/assets/banner/${this.safeLocale}/banner_mobile.jpg?v=2`;
    }
  },
  methods: {
    handleImageError (event) {
      if (this.safeLocale !== DEFAULT_LOCALE) {
        const path = event.target.src;
        event.target.src = path.replace(`/${this.safeLocale}/`, `/${DEFAULT_LOCALE}/`);
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .keyVisualWrapper {
    position: relative;
  }

.desktop_img {
  @media (max-width: 768px) {
    display: none;
  }
}

.tablet_img {
  @media (max-width: 435px), (min-width: 769px) {
    display: none;
  }
}

.mobile_img {
  @media (min-width: 436px) {
    display: none;
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

</style>
